import widgetFactory from '../widgetFactory';
import responsiveService from '../../Services/responsive';
import slidingSidebarWidget from '../ui/slidingSidebar';

const widgetName = 'contentWithSidebar';

const widget = widgetFactory(widgetName, {
  options: {},

  _create: function () {
    this._super(widgetName);
    this.elements.$slidingElement = this.getWidgetElement('slidingElement');

    responsiveService.registerOnChangeCallback(this._onResponsiveWidthChange.bind(this));

    if (!this.elements.$slidingElement.length) {
      return;
    }

    if (responsiveService.getCurrent() === responsiveService.SCREEN_WIDTH_MEDIUM) {
      this._enableSlidingBar();
    }
  },

  _onResponsiveWidthChange: function (width) {
    if (width === responsiveService.SCREEN_WIDTH_MEDIUM) {
      this._enableSlidingBar();
    } else {
      this._disableSlidingBar();
    }
  },

  _enableSlidingBar: function () {
    if (!this.elements.slidingBar) {
      this.elements.slidingBar = slidingSidebarWidget.create(this.elements.$slidingElement);
    } else {
      this.elements.slidingBar.enable();
    }
  },

  _disableSlidingBar: function () {
    if (this.elements.slidingBar) {
      this.elements.slidingBar.disable();
    }
  },
});

export default widget;
